import theme from '../../../lib/theme';
import { HolidaysBlockProps } from './HolidaysBlock';

const { scale, layouts, media } = theme;

export default ({ columns = 3, isV2Collection = false }: HolidaysBlockProps) => ({
  container: {
    ...(isV2Collection ? layouts.column : layouts.spacedColumn('m')),
  },

  holidays: {
    ...layouts.column,

    alignItems: 'stretch',

    [media.s.up]: {
      ...layouts.row,

      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },

  holidaysContainer: {
    ...layouts.spacedColumn('s'),
  },

  heading: {
    ...layouts.container('m'),
    ...layouts.spacedColumn('xs'),
  },

  holiday: {
    marginBottom: scale.m,
    flex: `100% 0`,

    [media.s.up]: {
      flex: `calc(50% - ${scale.m} / 2) 0`,
      marginRight: scale.m,
    },

    [media.l.up]: {
      flex:
        columns === 3
          ? `calc(33.33% - ${scale.m} * 2 / 3) 0`
          : `calc(50% - ${scale.m}  / 2) 0`,
    },

    '&:nth-child(3n)': {
      [media.l.up]: {
        marginRight: columns === 3 ? 0 : scale.m,
      },
    },

    '&:nth-child(2n)': {
      [media.s.up]: {
        marginRight: 0,
      },

      [media.l.up]: {
        marginRight: columns === 3 ? scale.m : 0,
      },
    },

    '&:nth-child(6n)': {
      [media.l.up]: {
        marginRight: 0,
      },
    },
  },

  loading: {
    backgroundImage:
      "url('https://images.startsat60.com/frontend/loading-spinner-sas.gif')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: 50,
    height: 10,
  },
});
